export default __webpack_public_path__ + "static/media/contact_form_logo.216056fb.png";